/* eslint-disable import/prefer-default-export */

import axios from './axios';

export const getEstimateTenderStatuses = ({ params } = {}) => axios.get(`estimate_tender_statuses`, { params });